import { useIntl } from "react-intl";
import Plus from "src/design-system/icons/Plus.svg?react";
import { tw } from "src/design-system/tw";
import { Button } from "react-aria-components";
import messages from "./AddDestinationTimelineButton.messages";

interface AddDestinationTimelineButtonProps {
  onClick: () => void;
  isDisabled: boolean;
  isTimeline?: boolean;
}

export function AddDestinationTimelineButton(
  props: AddDestinationTimelineButtonProps,
) {
  const { onClick, isDisabled } = props;
  const intl = useIntl();

  return (
    <Button
      className={tw(
        "group relative flex items-center justify-start py-4 pr-4 pl-0 font-medium text-text-brand",
        isDisabled && "text-text-tertiary",
      )}
      isDisabled={isDisabled}
      onClick={onClick}
    >
      <div className="flex items-center group-focus-visible:outline-2">
        <Plus
          className={tw(
            "z-1 mr-3 ml-2.5 h-5.5 w-5.5 text-icon-brand",
            isDisabled && "text-text-tertiary",
          )}
        />
        <span className="mr-2.5">
          {intl.formatMessage(messages.addDestination)}
        </span>
      </div>
    </Button>
  );
}
